import { gql } from "@apollo/client";

/**
 * Create Quotation
 */
export const CREATE_QUOTATION = gql`
  mutation createQuotation($input: createQuotationInput) {
    createQuotation(input: $input) {
      Id
      membershipId
      quotationNumber
      subject
      parameters
      date
      createdAt
    }
  }
`;

/**
 * Update Quotation by ID
 */


/**
 * Delete Quotation by ID
 */


/**
 * Get All Quotations
 */


/**
 * Get Quotation by ID
 */


/**
 * Get Latest Quotation Number (for prefix-based auto-increment)
 */

